<template>
  <t-modal
    v-bind="$attrs"
    v-model="open"
    :class="[ open ? 'fadeIn' : 'fadeOut' ]"
    :hide-close-button="hideCloseButton"
    :variant="variant"
    aria-label="Common Modal"
    aria-modal
    aria-role="dialog"
    class="animated"
    @closed="$emit('close')"
  >
    <template #header v-if="showHeader && !loading">
      <slot name="header" />
    </template>
    <slot v-if="!loading" />
    <div v-else>
      <w-loading :is-full-page="false" color="primary-500" />
    </div>
    <template #footer v-if="showFooter && !loading">
      <slot name="footer" />
    </template>
  </t-modal>
</template>

<script>
import WModal from './WModal';

export default WModal;
</script>

<style lang="scss" scoped>
@import 'WModal';
</style>
